import React from "react";

const AlumniFilled = ({color = "currentColor"}) => (
    <svg width="25" height="25" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 33 26">
        <g fill="none" fillRule="evenodd">
            <path
                d="M13.094.598c7.169 0 6.657 4.915 6.657 4.915L19.228 9.2l-.023-.055c-.18-.396-.51-.683-.99-.683l-.512-2.458c-4.097 0-4.097-1.474-4.609-1.966-.512.492-.512 1.966-4.608 1.966l-.512 2.458c-.48 0-.81.287-.99.683l-.022.055-.524-3.687S5.926.598 13.094.598z"
                fill={color}
            />
            <path
                d="M13.094 16.325c1.537 0 5.12-1.966 5.12-4.915 1.537 0 1.537-2.948 0-2.948l-.511-2.458c-4.097 0-4.097-1.474-4.609-1.966-.512.492-.512 1.966-4.608 1.966l-.512 2.458c-1.536 0-1.536 2.948 0 2.948 0 2.949 3.584 4.915 5.12 4.915z"
                stroke={color}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M10.49 15.356l-6.513 1.71c-1.6.576-2.66 2.042-2.66 3.682v2.457h14.85v-7.85l-3.073 1.99-2.604-1.99z"
                stroke={color}
                fill={color}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M10.022 9.446c0-.543.458-.491 1.024-.491.567 0 1.024-.052 1.024.491M14.118 9.446c0-.543.458-.491 1.025-.491.566 0 1.024-.052 1.024.491"
                stroke={color}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <g fill={color}>
                <path d="M17.947 26.5h14.167l.123-.006c-.04.004-.081.006-.123.006H17.947l-.123-.006.123.006zm14.367-9.508V25.3a.2.2 0 01-.2.2H17.947a.2.2 0 01-.2-.2v-8.307l.913 2.88a1.4 1.4 0 001.195.97l.14.008 3.823-.002v.96a.6.6 0 00.503.592l.097.008h1.225a.6.6 0 00.592-.503l.008-.097-.001-.96 3.825.002a1.4 1.4 0 001.286-.847l.049-.13.912-2.882zm-6.871 2.516v2.101h-.825v-2.101h.825zm-6.784-4.47h12.743c.11 0 .2.09.2.2l-.002.03-.007.03-1.335 4.213a.2.2 0 01-.14.133l-.051.007-3.397-.001v-.185a1.2 1.2 0 00-1.077-1.194l-.122-.006h-.88a1.2 1.2 0 00-1.194 1.077l-.006.122v.186h-3.397a.2.2 0 01-.169-.093l-.021-.046-1.335-4.213a.2.2 0 01.13-.251l.03-.007.03-.002h12.743zm7.594-2.338l.167.912h-2.778l.166-.912h2.445zm0-1.2l.123.006-.123-.006h-2.445l-.034.002.009-.001.025-.001h2.445zm-2.48.002l-.087.004.06-.004h.028z" />
            </g>
        </g>
    </svg>
);

export default AlumniFilled;
